<template>
  <div class="col-3 filtersection pl-0">
    <div class="d-flex justify-content-between filtersection__texthead1">
      <span class="font-weight-bold">Filter</span>
      <span class="filtersection__reset" @click="resetFilter">Reset</span>
    </div>
    <div class="box">
      <div class="d-flex justify-content-between pb-1" style="font-weight: 600">
        <div>Shipping Lines</div>
        <div v-b-toggle="`collapse-shippinglines`">
          <img src="@/assets/image/icon/icon-dropdown-gray.svg" class="icondropdown toggle when-opened" alt="dropdown">
        </div>
      </div>
      <b-collapse id="collapse-shippinglines" visible> 
        <div v-for="(item) in filterShippingLine.list" :key="item.id">
          <div class="checkbox mt-2 mb-1">
            <div class="d-flex">
              <input v-model="filterShippingLine.checked" type="checkbox" :value="item.name" checked />
              <label class="my-0 mx-2" for="transshipments">{{ item.name }}</label>
            </div>
            <div>
              <span class="checkbox--number">{{item.total}}</span>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// eslint-disable-next-line import/no-cycle
import mixin from '@/mixin'

export default {
  name: 'FilterSectionVesselSchedule',
  mixins: [mixin],
  props: {
    dataVesselShipment: Array
  },
  data () {
    return {
      filterShippingLine: {
        list: [],
        checked: []
      }
    }
  },
  computed: {
    ...mapGetters({
      dataFetchVesselSchedule: 'vesselSchedule/dataVesselSchedule',
      isLoadingDataVesselSchedule: 'vesselSchedule/isLoadingDataVesselSchedule',
      errorDataVesselSchedule: 'vesselSchedule/errorDataVesselSchedule'
    })
  },
  created () {
    this.countFilterShippingLine()
  },
  watch: {
    'filterShippingLine.checked': {
      handler: function (newVal) {
        this.$emit('filterShippingLine', newVal)
      },
      deep: true
    }
  },
  methods: {
    resetFilter () {
      this.filterShippingLine.list = []
      this.filterShippingLine.checked = []
      this.countFilterShippingLine()
    },
    countFilterShippingLine () {
      let duplicateCount = {}
      let shippingLineAvail = new Set()
      this.dataFetchVesselSchedule.forEach((el) => {
        el.dataScheduleShipment.forEach(({ shippingLine }) => {
          duplicateCount[shippingLine] = (duplicateCount[shippingLine] || 0) + 1
          shippingLineAvail.add(shippingLine)
        })
      })
      this.filterShippingLine.checked = [...shippingLineAvail]
      this.filterShippingLine.list = Object.keys(duplicateCount).map(el => { return { name: el, total: duplicateCount[el] } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/FilterSection.vue